import { render, staticRenderFns } from "./UserOnboarding.vue?vue&type=template&id=b181603e&scoped=true&"
import script from "./UserOnboarding.vue?vue&type=script&lang=js&"
export * from "./UserOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./UserOnboarding.vue?vue&type=style&index=0&id=b181603e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b181603e",
  null
  
)

export default component.exports